var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-list',_vm._l((_vm.pages),function(page,index){return _c('ion-item',{key:index,attrs:{"href":page.fullPath},on:{"click":function($event){$event.preventDefault();return _setup.go(page.fullPath, page.external)}}},[_c('ion-label',[_vm._v(_vm._s(page.label))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }